import { apiSlice } from "features/api/apiSlice";
import { transformDoctor } from "./transformDoctor";

const getOnlineDoctors = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getOnlineDoctors: build.query({
      query: ({ filter, isPremium, isCounselor }) => {
        const params = new URLSearchParams({
          ...(filter && { specializations: filter }),
          ...(isPremium && { joinSubscription: true }),
          ...(typeof isCounselor === "boolean" && { isCounselor: isCounselor }),
        });
        return `/doctors/mwell/oncall/list?${params}`;
      },
      transformResponse: (res, _meta, arg) => {
        const isCounselor = arg?.isCounselor === true;
        return res.d.map((d) => transformDoctor(d, isCounselor));
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetOnlineDoctorsQuery } = getOnlineDoctors;
